const actionTypes = {
  SET_CONSTRAINTS: '@WS/SET_CONSTRAINTS',
};

export default actionTypes;
